import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferOffer } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { ERR_ACC_XFER_REQ, SUC_ACC_XFER_REQ } from '../../../../utils/strings';

export const useAcceptTransferOffer = () => {
  const { submit } = useExerciseSubmission(
    TransferOffer.TransferOffer_Accept,
    SUC_ACC_XFER_REQ,
    ERR_ACC_XFER_REQ,
  );
  return submit;
};
